<template>
  <div class="tip1_box" v-show="list.length != 0">
    <div class="title_box">
      <span class="title">{{ title }}</span>
      <span class="more_btn" @click="goDetail">更多</span>
    </div>
    <div class="tip_part">
      <div
        class="tip_item"
        v-for="(item, index) in list"
        :key="index"
        @click="detailClick(item.id)"
      >
        {{ item.title }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String, // 字符类型
      required: true // 必要条件
    },
    list: {
      type: Array,
      required: true
    }
  },
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    goDetail() {
      this.$router.push({ name: 'detailPage', params: { title: this.title } });
    },
    detailClick(id) {
      let _path = '../topicPage/?topicId=' + id + '&isGame=true';
      this.$router.push({
        path: _path
      });
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang='scss' scoped>
.gl .side_box .tip1_box {
  width: 100%;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  box-shadow: 0 0.03rem 0.05rem 0 rgba(235, 235, 235, 0.55);
  border-radius: 0.2rem;
  padding-top: 0.2rem;
  padding-bottom: 0.1rem;
  margin-bottom: 0.2rem;
  .title_box {
    margin: 0 0.21rem;
    margin-bottom: 0.2rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title {
      font-weight: bold;
      color: #2b2b2b;
      font-size: 0.24rem;
    }
    .more_btn {
      font-weight: 500;
      color: #8a98a4;
      font-size: 0.2rem;
      cursor: pointer;
    }
  }
  .tip_part {
    margin: 0 0.21rem;
    display: flex;
    flex-wrap: wrap;
    .tip_item {
      background: #f2f2f4;
      padding: 0.12rem 0.19rem;
      margin-right: 0.1rem;
      margin-bottom: 0.1rem;
      font-weight: 400;
      color: #2b2b2b;
      font-size: 0.2rem;
      cursor: pointer;
    }
  }
}
</style>